import React from "react";
import Navbar from "./Navbar";


function AdminHome() {
    return(
        <>
        <Navbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Admin Home</h2>
        </div>
        </>
    );
}
export default AdminHome;